import axios from 'axios'
import router from './router'
import { domain,toast } from './utils/utils.js';
axios.defaults.timeout = 5000;        
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';        //配置请求头
axios.defaults.headers['XX-Device-Type'] = 'wxapp'

axios.defaults.baseURL=domain
//(添加请求拦截器)
  axios.interceptors.request.use(
    config => {
        let token=localStorage.getItem('token')?localStorage.getItem('token'):''
      if (token != null) {
        config.headers["XX-Token"] = token
        
      }
  
      return config;
    },
    err => Promise.reject(err)
  );
//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) =>{
    if(res.data.code=='10001'){
        toast('登录失效，请重新登录')
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        localStorage.setItem('loginStus',false)
        router.push('/transfer')
        return;
    }
    if(!res.data.success){
        return Promise.resolve(res);
    }
    
    return res;
}, (error) => {
    console.log('网络异常')
    return Promise.reject(error);
});

//返回一个Promise(发送post请求)
export function fetchPost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error)
            })
    })
}
////返回一个Promise(发送get请求)
export function fetchGet(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params: param})
            .then(response => {
                resolve(response)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
export function getQueryString(key){
  
    var after = window.location.search;
    let afterH=window.location.hash
    if(after.indexOf('?') === -1&&afterH.indexOf('?') === -1) return null; 

    //key存在先通过search取值如果取不到就通过hash来取
    after = after.substr(1) || window.location.hash.split("?")[1];

    if(after)
    {
        var reg = new RegExp("(^|&)"+ key +"=([^&]*)(&|$)");
        var r = after.match(reg);
        if(r != null)
        {
            return  decodeURIComponent(r[2]);
        }
        else
        {
            return null;
        }
    }
}

export default {
    fetchPost,
    fetchGet,
    getQueryString
}


// WEBPACK FOOTER //
// ./src/https.js